import { ICourse } from '@/shared/ICourse';
import { MenuItem } from '@chakra-ui/react';
import { FiMail } from 'react-icons/fi';
import { WorkflowService } from '@/shared/WorkflowService';
import { AuthService } from '../services/AuthService';

export const MenuItemInviteExpert = (props: {
  course: ICourse,
  onInviteExpert: (course: ICourse) => void
}) => {

  const roles = AuthService.getCourseRoles(props.course);
  const isDisabled = !WorkflowService.isAssignToExpertEnabled(props.course, roles);
  return <MenuItem isDisabled={isDisabled} icon={<FiMail />} onClick={() => props.onInviteExpert(props.course)} >Assign to an External Reviewer...</MenuItem>
}
